const Layout = () => import(/* webpackChunkName: "Layout" */ "../views/Layout.vue");

const OrtherFacilities = () => import(/* webpackChunkName: "Home" */ "../views/ortherFacilities/Index.vue");
export default [
  {
    path: "/other-facilities",
    name: "other-facilities",
    component: Layout,
    meta: {
      title: "餐饮与其他设施",
      titleEn: "Catering and Other Facilities",
    },
    children: [
      {
        path: "",
        component: OrtherFacilities,
      },
    ],
  },
];
